module.exports = __webpack_public_path__ + "assets/3b534a37549fc38b5b96ecb18793faf7.jpg";